<template>
  <div class="row">
    <ul class="progressbar text-center">
      <progress-step
        v-if="order === 'licence'"
        :stepNumber="changeLicenceStepNumber"
        description="Podaj dane"
        icon="fa fa-cubes"
      ></progress-step>
      <progress-step
        v-if="(order === 'licence' && !currentOs) || order === 'products'"
        description="Wybierz produkty"
        :stepNumber="productsStepNumber"
        icon="fas fa-cloud"
      ></progress-step>
      <progress-step
        v-if="(order === 'licence' && !currentOs) || order === 'products'"
        :stepNumber="cloudStepNumber"
        :description="cloudStepDescription"
        icon="fab fa-wpforms"
      ></progress-step>
      <progress-step
        :stepNumber="deliveryStepNumber"
        description="Dostawa i płatność"
        icon="fas fa-truck"
      ></progress-step>
      <progress-step
        :stepNumber="summaryStepNumber"
        description="Podsumowanie"
        icon="far fa-address-card"
      ></progress-step>
    </ul>
  </div>
</template>

<script>
import ProgressStep from './ProgressStep';
import { mapGetters } from 'vuex';
import { accountant, company } from '../../config/cloud';

export default {
  name: 'ProgressSteps',
  components: { ProgressStep },
  props: {
    order: {},
    isAccountant: { type: Boolean, default: false },
    skpCompanyAdd: { type: Boolean, default: false },
    skpAccountantAdd: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters({
      program: 'getProgram',
      client: 'auth/client',
      currentOs: 'auth/currentOs',
      cartProducts: 'order/getCartProducts',
    }),
    stepOneDescription() {
      if (this.order === 'licence') {
        return 'Podaj dane';
      }

      return 'Wybierz produkty';
    },
    changeLicenceStepNumber() {
      return 1;
    },
    productsStepNumber() {
      if (this.order === 'licence' && !this.currentOs) return 2;

      return 1;
    },
    cloudStepNumber() {
      if (this.order === 'licence' && !this.currentOs) return 3;

      return 2;
    },
    deliveryStepNumber() {
      if (this.order === 'licence' && this.currentOs) return 2;
      if (this.order === 'licence' && !this.currentOs) return 4;

      return 3;
    },
    summaryStepNumber() {
      if (this.order === 'licence' && this.currentOs) return 3;
      if (this.order === 'licence' && !this.currentOs) return 5;

      return 4;
    },
    cloudStepDescription() {
      return this.isAccountant || this.skpAccoutantAdd
        ? 'SKP24 Connect Biuro'
        : this.program === 'sam' && !this.skpCompanyAdd
        ? 'SAM<sup>®</sup> Firma w Chmurze'
        : 'SKP24 Connect Firma';
    },
  },
};
</script>

<style scoped></style>
